import { useContext } from "react";

import { FormContext, type FormContextValue } from "./_context";

export function useFormContext(): undefined | FormContextValue {
	return useContext(FormContext);
}
